import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20academic%20research%20concept%20with%20layered%20translucent%20geometric%20shapes%2C%20soft%20gradient%20from%20amber%20to%20cream%2C%20minimalist%20scholarly%20atmosphere%2C%20clean%20elegant%20composition%2C%20warm%20neutral%20palette%2C%20sophisticated%20intellectual%20aesthetic%2C%20no%20text%20or%20letters%2C%20smooth%20textures%2C%20atmospheric%20depth&width=1800&height=900&seq=hero-bg-main&orientation=landscape"
        alt="援助交配现象研究"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <span className="inline-flex items-center px-4 py-1.5 rounded-full text-xs font-medium bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/20 mb-6 whitespace-nowrap">
          <i className="ri-book-2-line mr-1.5"></i>
          学术研究 · 深度解析
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-6">
          援助交配
          <span className="block text-2xl md:text-3xl lg:text-4xl font-medium mt-3 opacity-90">
            深度解析与现象研究
          </span>
        </h1>
        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto leading-relaxed mb-10">
          围绕「援助交配」现象展开系统性研究，从社会背景、心理动因、法律规制到现实影响，
          提供客观、理性、多维度的学术分析视角与参考资料。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dingyi-jiedu"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-arrow-right-line"></i>
            开始阅读
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50/10 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-lg font-medium text-sm hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-information-line"></i>
            了解我们
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}